import { observer } from 'mobx-react'
import { useContext } from 'react'
import { Header } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'

export const SuccessEidCmcPage = observer(() => {
  const store = useContext(StoreContext)
  const { SuccessEidPage: trans } = store.TranslationsState.translations

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="success" />
      <Header className="m-0-0-30">{trans.header}</Header>
    </div>
  )
})
